import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const documentsApi = createApi({
  reducerPath: "documentsApi",
  baseQuery,
  tagTypes: ["Document"],
  endpoints: (builder) => ({
    getDocumentByTemplate: builder.query({
      query: ({ templatetype, jobid }) => ({
        url: `pdf/generate/${templatetype}/${jobid}`,
        method: "GET",
        responseHandler: async (response) => {
          const blob = await response.blob();
          return blob;
        },
      }),
      providesTags: ["Document"],
    }),
  }),
});

export const { useLazyGetDocumentByTemplateQuery } = documentsApi;
